/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PlayerType {
    Undefined = 0,
    MediaScreen = 1,
    Debriefing = 2,
    DigitalSignage = 4,
}
